/**
 * A farmer's or plot's address as the land record would read it: village, block, district,
 * state. Farmers carry no street address; the village is the address.
 */
export function placeLine(row: {
  village_name?: string | null;
  block_name?: string | null;
  district_name?: string | null;
  state_name?: string | null;
}): string {
  const parts = [row.village_name, row.block_name, row.district_name, row.state_name]
    .filter((part): part is string => Boolean(part && part.trim()));
  return parts.length ? parts.join(', ') : '--';
}
